import React, { ForwardRefExoticComponent, RefAttributes } from 'react'
import { Warehouse, House, Building, Store, BrickWall, Building2, LucideProps } from 'lucide-react'

export interface ProjectIcon {
  icon: ForwardRefExoticComponent<Omit<LucideProps, 'ref'> & RefAttributes<SVGSVGElement>>
  iconName: string
}

export const PROJECT_ICONS: ProjectIcon[] = [
  {
    icon: House,
    iconName: 'House',
  },
  {
    icon: Building,
    iconName: 'Building',
  },
  {
    icon: Building2,
    iconName: 'Building2',
  },
  {
    icon: Warehouse,
    iconName: 'Warehouse',
  },
  {
    icon: Store,
    iconName: 'Store',
  },
  {
    icon: BrickWall,
    iconName: 'BrickWall',
  },
]

export const getProjectIcon = (iconName?: string) => {
  if (!iconName) {
    return House
  }

  const projectIcon = PROJECT_ICONS.find((icon) => icon.iconName === iconName)

  return projectIcon ? projectIcon.icon : House
}
